import { FC, HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, Typography } from 'antd';
import cn from 'classnames';

import styles from './OfferCompanyCard.module.scss';

interface ITaskCompanyCardProps extends HTMLAttributes<HTMLDivElement> {
}

export const OfferCompanyCard: FC<ITaskCompanyCardProps> = ({
	className,
	...props
}) => {
	const { t } = useTranslation();

	return (
		<Flex
			{...props}
			className={cn(className, styles.card)}
			vertical
			gap={21}
			style={{ width: '100%' }}
			justify="space-between">
			<Typography.Title level={5} style={{ margin: 0}}>{t('About STREET BEAT')}</Typography.Title>
			<Typography.Text>{t('A chain of multi-brand stores offering footwear, clothing, and accessories from global sports and lifestyle brands such as Adidas, Reebok, Puma, Converse, Dr. Martens, The North Face, and others.')}</Typography.Text>
			<Typography.Link href={'#'}>{t('See more')}</Typography.Link>
		</Flex>
	);
};
